import React, { useState, useEffect } from "react";
import { get } from "lodash";
import QuizCard from "./Quizcard";
import Leaderboard from "./Leaderboard";
import styles from "./quiz.m.css";
import { connect } from "react-redux";
import LoginMobile from "../../rows/header/user-login/login-mobile";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const thinmint = cookies.get("vikatanthinmint") || cookies.get("thinmint");

function QuizHome(props) {
  const [userId, setUserId] = useState("");
  const [loggedOut, setLoggedOut] = useState(true);
  const [isReady, setIsReady] = useState(false);
  const jwtKey = get(props, ["jwtKey"], "");
  const quizType = get(props, ["metadata", "quiztype"]);
  const showleaderboard = get(props, ["metadata", "showleaderboard"]);
  const [IsOpened, setIsOpened] = useState(false);

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      const uid = user ? get(user, ["userId"], "") : "";
      const isLoggedOut = user ? get(user, ["loggedOut"], true) : true;
      setUserId(uid);
      setLoggedOut(isLoggedOut);
      setIsReady(true);
    });
  }, []);

  if (!isReady) return null;

  const handleMobileLoginClose = () => {
    setIsOpened(false);
  };

  return (
    <div className={`${styles["quiz-app"]} container`}>
      <div className={styles["quiz-app__left"]}>
        {loggedOut || !userId ? (
          <div className={styles["quiz-card-wrapper"]}>
            <div className={styles["quiz-card"]}>
              {/* {Fallback && (
            <div>
              <img src={Fallback} />
            </div>
          )} */}
              <img src="https://media.vikatan.com/vikatan/2026-03-25/gglp5c6u/Vikatan_Thatha_payment_logo_new.png" />
              <p className={styles["quiz-card__status"]}>Please log in to take the quiz.</p>
              {/* <button className={styles["quiz-submit-btn"]} onClick={() => setIsOpened(true)}>
                Login
              </button> */}
              <button className={styles["quiz-submit-btn"]} onClick={() => setIsOpened(true)}>
                <span>Login</span>{" "}
                <img src="https://images.assettype.com/vikatan/2026-03-24/ceudk8q0/arrow.png" alt="" />
              </button>
            </div>
          </div>
        ) : (
          <QuizCard userId={userId} jwtKey={jwtKey} quizType={quizType} showleaderboard={showleaderboard} />
        )}
      </div>
      {IsOpened && <LoginMobile onClose={handleMobileLoginClose} />}
      {isReady && (
        <div className={styles["quiz-app__right"]}>
          <Leaderboard
            userId={userId || thinmint || "30ca330f-1758-4612"}
            jwtKey={jwtKey}
            quizType={quizType}
            showleaderboard={showleaderboard}
          />
        </div>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return { jwtKey: get(state, ["qt", "config", "JwtKey"]) };
}

export default connect(mapStateToProps)(QuizHome);
